// lib/comments.js
import supabase from "../supabase";

export async function createComment({
  article_id,
  exact_text,
  occurrence_index = 0,
  prefix,
  suffix,
  body,
  status = "open",
  created_by,
}) {
  const { data, error } = await supabase
    .from("article_comments")
    .insert([
      { article_id, exact_text, occurrence_index, body, status, created_by },
    ])
    .select("*")
    .single();
  if (error) throw error;
  return data;
}

// Existing signature: export async function listComments(article_id) { ... }
export async function listComments(article_id, status) {
  let q = supabase
    .from("article_comments")
    .select(
      "id, exact_text, occurrence_index, prefix, suffix, body, status, created_at, created_by"
    )
    .eq("article_id", article_id)
    .order("created_at", { ascending: false });

  if (status) q = q.eq("status", status);

  const { data, error } = await q;
  if (error) throw error;
  return data || [];
}

export async function setCommentStatus(id, status = "resolved") {
  const { data, error } = await supabase
    .from("article_comments")
    .update({ status })
    .eq("id", id)
    .select("id, status")
    .single();
  if (error) throw error;
  return data;
}

export async function resolveComment(id) {
  const { data, error } = await supabase
    .from("article_comments")
    .update({ status: "resolved" })
    .eq("id", id)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteComment(commentId) {
  const { error } = await supabase
    .from("article_comments")
    .delete()
    .eq("id", commentId);
  if (error) throw error;
}

// Get replies for one comment
export async function listReplies(commentId) {
  const { data, error } = await supabase
    .from("article_comment_replies")
    .select(
      "id, comment_id, body, created_by, created_at, Users:created_by (name, email)"
    )
    .eq("comment_id", commentId)
    .order("created_at", { ascending: true });
  if (error) throw error;
  // normalize author fields
  return (data || []).map((r) => ({
    ...r,
    author_name: r.Users?.name || r.Users?.email || r.created_by,
  }));
}

// Create a reply
export async function addReply({ comment_id, body }) {
  const { data, error } = await supabase
    .from("article_comment_replies")
    .insert([{ comment_id, body }])
    .select("id, comment_id, body, created_by, created_at");
  if (error) throw error;
  return data?.[0];
}

// Delete a reply (author OR Admin/Editor per RLS)
export async function deleteReply(replyId) {
  const { error } = await supabase
    .from("article_comment_replies")
    .delete()
    .eq("id", replyId);
  if (error) throw error;
}
